import { Routes, RouterModule } from '@angular/router';
import { Constants, AuthGuard } from '@app/shared.module';

import { LoginComponent } from '@app/login.module';
import { PageNotFoundComponent } from './shared.module';

export const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: `${Constants.routerPaths.login}`, component: LoginComponent },
    { path: `${Constants.routerPaths.app}`, loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard] },
    { path: `${Constants.routerPaths.pageNotFound}`, component: PageNotFoundComponent },
    { path: `${Constants.routerPaths.noMatch}`, component: LoginComponent },
];

export const AppRoutes = RouterModule.forRoot(routes);
